import { api } from './client';
import type {
  JournalEntry,
  JournalEntryCreate,
  JournalEntryUpdate,
  JournalEntryListResponse,
} from '@/types/journal';

export const journalApi = {
  /**
   * List journal entries for a tank.
   */
  async list(
    tankId: string,
    params?: { search?: string }
  ): Promise<JournalEntryListResponse> {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.set('search', params.search);

    const query = searchParams.toString();
    const url = `/api/tanks/${tankId}/journal${query ? `?${query}` : ''}`;
    return api.get(url);
  },

  /**
   * Get a single journal entry.
   */
  async get(tankId: string, entryId: string): Promise<JournalEntry> {
    return api.get(`/api/tanks/${tankId}/journal/${entryId}`);
  },

  /**
   * Create a new journal entry.
   */
  async create(tankId: string, data: JournalEntryCreate): Promise<JournalEntry> {
    return api.post(`/api/tanks/${tankId}/journal`, data);
  },

  /**
   * Update a journal entry.
   */
  async update(
    tankId: string,
    entryId: string,
    data: JournalEntryUpdate
  ): Promise<JournalEntry> {
    return api.put(`/api/tanks/${tankId}/journal/${entryId}`, data);
  },

  /**
   * Toggle pinned status.
   */
  async togglePin(tankId: string, entryId: string): Promise<JournalEntry> {
    return api.patch(`/api/tanks/${tankId}/journal/${entryId}/pin`);
  },

  /**
   * Delete a journal entry.
   */
  async delete(tankId: string, entryId: string): Promise<void> {
    return api.delete(`/api/tanks/${tankId}/journal/${entryId}`);
  },
};
